//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/button'

//#endregion


import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { CommonHelper } from '../../../helpers/common-helper'

//#region Asset Imports

import './form-button.scss'
import * as TEMPLATE from './form-button.tpl.html'

//#endregion

export interface FormButtonOptions {
    type: string
    buttonHint: string
    elementId: number
    propertyName: string
    index: number
}

export interface FormButtonScope extends ng.IScope {
    options: FormButtonOptions
    callback: (options: FormButtonOptions) => void

    buttonOptions: DevExpress.ui.dxButtonOptions

    button: DevExpress.ui.dxButton
}

export class FormButtonDirective implements ng.IDirective {
    isPopupVisible: boolean

    constructor() { }

    restrict = 'E'
    scope = {
        options: '=',
        callback: '='
    }

    controller = ['$scope', '$q', '$timeout', 'api', 'localDictionary', ($scope: FormButtonScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, localDictionary: LocalDictionaryFactory) => {
        let oldScript

        $scope.buttonOptions = {
            template: CommonHelper.getIconWithText($scope.options.buttonHint, $scope.options.type), //TODO check what and from it comes for changes into templatehelper
            hint: $scope.options.buttonHint,
            onInitialized: e => {
                $scope.button = e.component
            },
            onClick: e => {
                if ($scope.callback)
                    $scope.callback($scope.options)
            }
        }
    }]
    template = TEMPLATE
    transclude = true
}